
{
  "_comment": "this file is automatically generated, do not edit",
  "name": "chatbot-ui",
  "version": "1.0.0",
  "commit": "0a184d9ad125ff48659b024b962d8d494bd138bf",
  "commitShort": "0a184d9a",
  "branch": "develop",
  "tag": "unknown",
  "refName": "develop",
  "buildNumber": "240",
  "buildTime": "2026-07-24T03:58:33Z"
}
